import { Box } from '@mui/material';
import { useNavigate } from 'react-router';

import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { pricingRoutesConfig } from 'domains/pricing/routes';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';

import { BannerSkeleton } from '../BannerSkeleton';
import { UpgradePublicBanner } from './UpgradePublicBanner';

export const UpgradePlanBanner = () => {
  const {
    initialLoading: accountStatusLoading,
    isEnterprise,
    isPremium,
  } = useAccountStatus();

  const navigate = useNavigate();

  // Upgrade plan banner should be hidden for premium and enterprise users on chains page
  // as we are now showing them the request banner with the same call to action
  if (isPremium || isEnterprise) return null;

  if (accountStatusLoading) return <BannerSkeleton />;

  const onPremiumButtonClick = () =>
    navigate(pricingRoutesConfig.pricing.generatePath());

  return (
    <GuardAccountPermission permission={AccountPermission.UpgradePlan}>
      <Box sx={{ mb: 8 }}>
        <UpgradePublicBanner onGetPremiumButtonClick={onPremiumButtonClick} />
      </Box>
    </GuardAccountPermission>
  );
};
